var React = require('react');

function IconClose (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M7.73359 17.6831C7.32588 18.0908 6.70284 18.1126 6.29513 17.7049C5.88742 17.2972 5.9254 16.6579 6.33311 16.2502L10.584 12.001L6.31686 7.73359C5.94052 7.35724 5.89305 6.79741 6.20865 6.39284L6.29513 6.29513C6.70284 5.88742 7.34212 5.9254 7.74983 6.33311L12 10.584L16.2664 6.31686C16.6428 5.94052 17.2026 5.89305 17.6072 6.20865L17.7049 6.29513C18.1126 6.70284 18.0746 7.34212 17.6669 7.74983L13.417 12L17.6831 16.2664C18.0595 16.6428 18.1069 17.2026 17.7914 17.6072L17.7049 17.7049C17.2972 18.1126 16.6579 18.0746 16.2502 17.6669L12.001 13.417L7.73359 17.6831Z","fill":"#0061EE"}));
}

IconClose.defaultProps = {"viewBox":"0 0 24 24","fill":"none"};

module.exports = IconClose;

IconClose.default = IconClose;
